<template>
  <!-- <div class="project-leading-box" v-show="DialogVisible"> -->
  <el-dialog
    class="modal project-leading"
    :title="DialogTitle"
    :visible="DialogVisible"
    :close-on-click-modal="false"
    @close="$emit('close', false)"
    width="500px"
  >
    <div class="dialog-title" slot="title">
      <i class="el-icon-folder-opened" style="font-size: 24px;"></i>
      {{DialogTitle}}
    </div>
    <div class="project-lead-main">
      <div class="form-row" v-if="!hasProject">
        <div class="form-row-label">{{ $t('projectSite') }}<span class="require">*</span></div>
        <div class="form-row-content">
          <el-input v-model="project.site" />
        </div>
      </div>
      <div class="form-row" v-if="!hasProject">
        <div class="form-row-label">{{ $t('projectNote') }}</div>
        <div class="form-row-content">
          <el-input v-model="project.descr" />
        </div>
      </div>
      <div class="form-row">
        <div class="form-row-label">{{ $t('projectLeadRowName') }}<span class="require">*</span></div>
        <div class="form-row-content">
          <label class="font_color">
              <span>{{files_path}}</span>
            <span>{{tips}}</span>
            <input
              @change="file_change($event)"
              type="file"
              class="files"
              webkitdirectory
              name="fileFolder"
              id="fileFolder"
              multiple
              ref="fileFolder"
            />
          </label>
        </div>
      </div>
      <div class="form-row slot" v-if="!hasProject">
        <div class="form-row-label">{{ $t('projectPanelMode') }}</div>
        <div  style="margin-top: 20px;">
          <el-radio class="content-input" v-model="project.panelType" :label="0">{{ $t('projectPanelTypeSingle') }}</el-radio>
          <el-radio class="content-input" v-model="project.panelType" :label="1">{{ $t('projectPanelTypeNetwork') }}</el-radio>
        </div>
      </div>
    </div>
    <div class="projectl-lead-button">
      <el-button class="gray-btn" @click="$emit('close', false)">{{ $t('cancel') }}</el-button>
      <el-button class="blue-btn" @click="saveData" :loading='loading'>{{ $t('sure') }}</el-button>
    </div>
  </el-dialog>
  <!-- </div> -->
</template>
<script>
import { folderLeadingIn, projectNew, projectLeadingIn} from "../../api/config";
import config from '../../common/config'
import Cookies from 'js-cookie'
import { Loading } from 'element-ui'

export default {
  name: "ProjectLead",
  props: {
    DialogVisible: {
      type: Boolean,
      default: false
    },
    hasProject:{
      type: Boolean,
      default: false
    },
    projectId:''
  },
  data() {
    return {
      DialogTitle: this.$t("projectLeadTitle"),
      tips: this.$t("projectLeadRowButtom"),
      project: {
        site: '',
        descr: '',
        panels: [],
        panelType:0,
        loadingText: this.$t('globalLoadingText')
        // userId: JSON.parse(sessionStorage.userInfo).id
      },
      files_count:'',
      files_path:'',
      formData:'',
      loading:false,
      loadingInstance: null
    };
  },
  mounted(){
    
  },
  methods: {
    async saveData() {
        let projectId
        // firstLoad 是否是第一次加载
        let firstLoad = 0
        if(!this.hasProject){   //没有项目 需新建
            if(!this.project.site){
                this.$message.warning(this.$t('projectAddRequired'))
                 return
            }
            if(!this.formData){
                 this.$message.warning(this.$t('projectAddRequired'))
                return
            }
            firstLoad = 1
            projectId = await this.project_new();
        }else{
            projectId = this.projectId
        }
        let file_path = await this.upload_file();
        let params = {
            projectId: projectId,
            path: file_path,
            panelType:this.project.panelType,
            userId: Cookies.get(config.userId),
            firstLoad: firstLoad,
            loadingText: this.$t('globalLoadingText')
        }
        this.showLoading()
        this.loading = true;
        projectLeadingIn(params).then(res=>{
            if(res.code == 1){
              this.loading = false;
              this.closeLoading()
              this.project.site = '';
              this.project.descr = '';
              this.$message.success(this.$t("projectLeadSuccess"));
              this.$emit('close', false);
              // this.$emit('goRouter', res.data.panels)
              // if (this.hasProject) {
                this.$emit('goRouter', res.data)
              // }
              this.$emit('callback')
              // 导入数据成功后刷新页面
              setTimeout(() => {
                window.location.reload()
              }, 2000)
            }
        }).catch(err=>{
            this.loading = false;
              this.closeLoading()
              this.project.site = '';
              this.project.descr = '';
              this.$message.success(this.$t("projectLeadSuccess"));
              this.$emit('close', false);
              // this.$emit('goRouter', res.data.panels)
              if (this.hasProject) {
                this.$emit('goRouter', res.data)
              }
              this.$emit('callback')
              // 导入数据成功后刷新页面
              setTimeout(() => {
                window.location.reload()
              }, 2000)
            console.log('ajax_err:',err)
        })
    },
    project_new() {
        return new Promise((resolve,reject)=>{
            this.project.userId = Cookies.get(config.userId)
            this.loading = true;
            projectNew(this.project).then(res=>{
              this.loading = false;
                if(res.code == 1){
                    resolve(res.data.id)
                }else{id
                    reject(false)
                }
            }).catch(err=>{
              this.loading = false;
                reject(false)
                console.log('ajax_err:',err)
            })
        })
    },
    file_change(event){
        this.files_count = event.target.files.length;
        let path = event.target.files[0].webkitRelativePath.split('/')[0]
        this.files_path = path.length>8?(path.slice(0,8) + '.../'):(path + '/');
        let files = event.target.files;
        this.formData = new FormData();
        for (let i = 0; i < this.files_count; i++) {
            this.formData.append("file", files[i]);
        }
    },
    upload_file(event) {
      return new Promise((resolve,reject)=>{
        this.loading = true;
        this.formData.append('loadingText', this.$t('globalLoadingText'))
        folderLeadingIn(this.formData).then(res => {
          this.loading = false;
            if (res.code == 1) {
              this.$refs.fileFolder.value = "";
              this.files_count = '';
              this.formData = '';
              // this.$message.success(this.$t("folderLeadSuccess"));
              resolve(res.data)
            }else{
              reject(false)
            }
        }).catch(err=>{
           this.loading = false;
           this.closeLoading()
            reject(false)
        });
      })
    },
    showLoading () {
      const options = {
        fullscreen: false,
        customClass: 'project-loading',
        background: 'rgba(255,255,255,.5)',
        text: this.$t('globalLoadingText'), // 显示在加载图标下方的加载文案
        spinner: '', // 自定义加载图标类名
      }
      // 显示loading
      this.loadingInstance = Loading.service(options)
    },
    closeLoading () {
      this.loadingInstance.close()
      this.loadingInstance = null
    }
  }
};
</script>

<style lang="less" scoped>
.project-leading {
  width: 100%;
  height: 100%;

  .project-lead-main {
    width: 100;
    .form-row {
      margin: 0 auto;
      margin-top: 30px;
      vertical-align: top;
      width: calc(100% - 100px);
      border-bottom: 1px solid #CCDEEE;
      .form-row-label {
        font-size: 16px;
        .require{
            color: red;
        }
      }
      .form-row-content {
            border-bottom: 1px solid #ccdeee;
            height: 33px;
            label{
                display: inline-block;
                width: 100%;
                height: 100%;
                display: flex;
                line-height: 33px;
                justify-content: space-between;
            
            }
            /deep/ .el-input{
                  border: none;
                  .el-input__inner{
                      border: none;
                  }
            }
            .font_color {
                cursor: pointer;

                .files {
                    display: none;
                }
            }
      }
    }
  }

  .projectl-lead-button {
    margin-top: 20px;
    text-align: right;
  }
}

</style>
<style lang="less">
.project-loading {
  z-index: 3000!important;
}
</style>